module.exports = __webpack_public_path__ + "img/Kaikas-logo-blanc.e300e2b6.svg";